<template>
<!-- This version displays 4 categories with sublinks  -->
  <div class="hpProductsWrap">
    <div class="" style="padding-left:10vw;padding-right:10vw;">
      <span class="hpSecTitle">{{localize('product_catalog')}}</span>
    </div>
    <div class="hpSecSub">
      <a>{{localize('explore_mis_products')}}  - <span>{{localize('view_catalog')}}</span></a>
    </div>    
    <!-- {{itemsData}} -->
    <!-- {{itemsData}} -->
    <br/>
    <br/>
    <div :class="['hpProducts']" style="padding-left:10vw;padding-right:10vw;" @mouseleave="activeIndex = -1"><!-- , 'mx-2xl' -->

      <ul>
        <li v-for="(item,index) in itemsData" :key="'product_'+index">
          <!-- <router-link :to="item.parent_url" class="hppContents"> -->
            <div class="hppContents">
            <div class="hppImg">
              <router-link :to="item.parent_url">
                <img :src="'https://www.mis-implants.com/upload/'+item.parent_img">
              </router-link>
            </div>
            <div class="hppTitleWrap">
              <div class="hppTitle">
                <!-- <span class="subtitle hpFont1">{{item.title}}</span><br/> -->
                <router-link :to="item.parent_url">
                  <span class="title hpFont2">{{item.title}}</span>
                </router-link>
              </div>        

              <!-- links -->
              <div class="hppSublinks">                  
                  <a :href="linkitem.url" v-for="(linkitem,linkindex) in item.children" :key="'item_'+index+'link_'+linkindex">
                      {{localize(linkitem.name)}}
                      <!-- {{linkitem.name}} -->
                  </a>
              </div>

            </div>

          </div>

          <div class="hppBorder"></div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>

import { mapState } from "vuex";

export default {
  props: {
    sectionData:{},
    children: {
      type: Array,
      required: true
    },
    size: String
  },
  components: { },
  data() {
    return {
      activeIndex: -1,
        ___itemsData:
        [
          {
            "title":"Implant Systems",
            "subtitle":"V3 Implant",
            "url":"",
            "img":"https://www.mis-implants.com/upload/catalog/products/large/V3-13330.png"
          },
                    {
            "title":"Prosthetic Options",
            "subtitle":"Thin impression coping",
            "url":"",
            "img":"https://www.mis-implants.com/upload/catalog/products/large/VN-IO401.png"
          },
          {
            "title":"MGUIDE",
            "subtitle":"MGUIDE value pack",
            "url":"",
            "img":"https://www.mis-implants.com/upload/catalog/products/large/MG-TMP10.png"
          }

        ]      
    };
  },
  mounted() {
    //console.log("$device > ", this.$device);
  },
  computed: {
    itemsData()
    {
      return this.sectionData.items;
    },
    //...mapState(["dimensions"]),
    parsedChildren() {
      return _.filter(this.children, "url");
    }
  },
  methods: {
    activateItem: _.debounce(function(index) {
      this.activeIndex = index;
    }, 300)
  }
};
</script>

<style lang="stylus" scoped>
.hpProductsWrap
  padding 4vw 0px 2vw 0px
  +below(815px)
    padding 16vw 0px 2vw 0px
  .hpProducts
    border solid 0px red  
    width 100%  
    background-color #f9f9f9
    +below(815px)
      background-color #ffffff
      padding-left 10vw
      padding-right 10vw
      padding-bottom 0px
      overflow-x scroll
      scroll-snap-type x mandatory
      -webkit-overflow-scrolling touch
      -ms-overflow-style none
      scrollbar-width none    
    ul
      column-gap 5px
      background-color #f9f9f9
      border solid 0px green
      margin 0px
      background-color #ffffff
      padding 0px
      display grid
      list-style none
      grid-template-columns repeat(4, 1fr)
      grid-template-columns repeat(4, 1fr)
      height 25vw
      width 100%    
      +below(815px)
        width 80vw  
        height 70vw
        background-color #fff
        column-gap 20px
      li
        +below(815px)
          width 80vw 
          height auto       
          scroll-snap-align center
          //border solid 2px red
        position relative
        top 0px
        height 25vw
        background-color #f9f9f9        
        //border solid 1px purple
        width 100%
        color red
        display flex
        flex-flow row wrap
        align-items center
        row-gap 0px        
        transition all ease 1s
        .hppBorder
          transition all ease 1s
          height 4px
          background-color #09b6f4
          position absolute
          bottom 0px
          display block
          width 100%
          opacity 0
        .hppContents
          border solid 0px red
          width 100%
          clear both
          display block
          text-align center
          .hppImg
            border solid 0px red
            height 15vw
            position relative
          img
            height 14vw
            width auto
            margin auto
            position absolute
            bottom 1vw
            left 50%
            transform translateX(-50%)
            +below(815px)
              height 30vw
              width auto
          .hppTitleWrap
            margin auto
            border solid 0px green
            max-width 78%
            transition all ease 1s
            width 100%
            height 6vw
            //padding-top 0px
            .hppTitle
              display inline-block
              position relative
              color #333333
              text-align left
              a
                color #333333
              span
                display inline-block
              .subtitle
                //font-size 12px
                font-weight 300 !important
              .title
                //font-size 20px
                font-weight 300 !important
                letter-spacing -1px !important
                text-align center

</style>


<style scoped>
  .hppSublinks 
  {
    padding-top: 10px;
      text-align: center;
      display: block;
      opacity: 0;
      transition: all ease 0.4s;
  }
  .hppSublinks a
  {
    font-size: 14px;
    color: #444444;
    display: block;
    text-align: center;
  }


  .hpProductsWrap .hpProducts ul li:nth-child(2),
  .hpProductsWrap .hpProducts ul li:nth-child(3),
  .hpProductsWrap .hpProducts ul li:nth-child(4)
  {
      border-left: solid 0px #fff;
  }

  

    /* portrait ipad pro */
    @media only screen 
      and (min-width: 1024px) 
      and (max-height: 1366px) 
      and (orientation: portrait) 
      and (-webkit-min-device-pixel-ratio: 1.5) {
        .hpProductsWrap .hpProducts ul li .hppContents .hppImg {
            height: 10vw;
            position: relative;
        }        
        .hpProductsWrap .hpProducts ul li .hppContents img {
            height: 10vw;
        }        
    }

    @media only screen and (min-width:2000px)
    {
        .hpProductsWrap .hpProducts ul 
        {
          height: 20vw;
        }
        .hpProductsWrap .hpProducts ul li
        {
          height: 20vw;
        }
        .hpProductsWrap .hpProducts ul li .hppContents .hppTitleWrap 
        {
          padding-top: 40px;
        }
        .hpProductsWrap .hpProducts ul li .hppContents .hppImg {
            height: 9vw;
            position: relative;
            top: 20px;
            transition: all ease 0.5s;
        }        
        .hpProductsWrap .hpProducts ul li .hppContents img {
            height: 9vw;
            bottom: 0;
            top: 20px;
        }        
        .hppSublinks a{
            font-size: 20px;
        }        

        .hpProductsWrap .hpProducts ul li:hover
        {
              top:-20px;
              height:calc(20vw + 60px) !important;
        }
        .hpProductsWrap .hpProducts ul li:hover .hppContents .hppImg
        {
              top:0px !important;
        }
        .hpProductsWrap .hpProducts ul li:hover .hppTitleWrap
        {
            padding-top:25px !important;
        }        
    }


    @media screen and (max-width: 815px){
      .hpProducts {
          -ms-overflow-style: none;  /* Internet Explorer 10+ */
          scrollbar-width: none;  /* Firefox */
      }
      .hpProducts::-webkit-scrollbar { 
          display: none;  /* Safari and Chrome */
      }

      .hppSublinks 
      {
          opacity: 1;
      }      
      .hpProductsWrap .hpProducts ul
      {
        height: 100vw;
      }
      .hpProductsWrap .hpProducts ul li .hppContents img{
          height: 35vw;
          width: auto;
          bottom: 20px;
      }
      .hppBorder
      {
        height:4px;
        opacity:1 !important;
      }
    }

    /* iPad pro Landscape */
    /* Declare the same value for min- and max-width to avoid colliding with desktops */
    /* Source: https://medium.com/connect-the-dots/css-media-queries-for-ipad-pro-8cad10e17106*/
    @media only screen 
      and (min-width: 1024px) 
      and (max-height: 1366px) 
      and (orientation: landscape) 
      and (-webkit-min-device-pixel-ratio: 1.5) 
      {
        .hpProductsWrap .hpProducts ul li .hppContents .hppImg{
            height: 9vw;
        }        
        .hpProductsWrap .hpProducts ul li .hppContents img
        {
          height: 9vw;          
        }        
        .hppSublinks 
        {
            opacity: 1;
        }        
    }

    @media (hover: hover) {
      .hppSublinks a:hover
      {
        color: #1894e2;
      }
      .hppContents:hover .hppSublinks
      {
        opacity: 1;
      }

      .hpProductsWrap .hpProducts ul li:hover
      {
            top:-20px;
            height:calc(25vw + 40px);
            background-color:#fefefe;
            filter:drop-shadow(-8px 4px 8px #cccccc) ;
      }
      .hpProductsWrap .hpProducts ul li:hover .hppTitleWrap
      {
          padding-top:20px;
      }
      .hpProductsWrap .hpProducts ul li:hover .hppBorder
      {
          opacity:1;
      }
      .hppTitle a:hover span
      {
          color: #1894e2;
      }
    }

    /* ipad Portrait */
    @media only screen 
      and (min-width: 1024px) 
      and (max-height: 1366px) 
      and (orientation: portrait) 
      and (-webkit-min-device-pixel-ratio: 1.5) {
        .hppSublinks 
        {
            opacity: 1;
        }      
        .hpProducts{ 
            padding: 0 5vw;
        }
        .hpProductsWrap .hpProducts ul
        {
          height:33vw;
        }
        .hpProductsWrap .hpProducts ul li
        {
            align-items: initial;
            height:33vw;
        }
        .hpProductsWrap .hpProducts ul li .hppContents
        {
          padding-top: 50px;
        }
        .hpProductsWrap .hpProducts ul li .hppContents .hppImg {
            height: 10vw;
            position: relative;
        }        
        .hpProductsWrap .hpProducts ul li .hppContents img {
            height: 10vw;
        }        

        
    }

</style>    

<!--
  +desktop()
    height 50vh
    _flex(row,wrap,stretch,space-evenly)

  +below(1100px)
    _flex(row,wrap,flex-start,space-between)
  @media (min-device-width: 1024px), (max-device-height: 1366px), (-webkit-min-device-pixel-ratio: 1.5)
    _flex(row,wrap,flex-start,space-between)
    height auto

-->
